/**
 * Runs on the "Offer Card Saved" page after Stripe redirects back.
 *
 * Stripe returns ?session_id=...&offer_id=... - we hand both to the backend,
 * which verifies the setup actually completed before flipping the offer from
 * 'pending_card' to 'pending' (live, visible in the admin queue).
 *
 * Harmless on the app's version of this page: without an offer_id in the
 * query string it does nothing at all.
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  var sessionId = params.get('session_id');
  if (!sessionId) return;

  var status = document.querySelector('[data-offer-activation-status]');

  function setStatus(text) {
    if (status) status.textContent = text;
  }

  setStatus('Finalizing your offer\u2026');

  fetch('/apps/einstein/storefront-offers/activate', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: sessionId }),
  })
    .then(function (res) {
      if (!res.ok) throw new Error('activation failed');
      return res.json();
    })
    .then(function () {
      setStatus('Your offer has been submitted. We\u2019ll be in touch soon.');
    })
    .catch(function (err) {
      console.error('[offers] activation failed', err);
      setStatus(
        'Your card was saved, but we couldn\u2019t finalize the offer automatically. Please contact us and we\u2019ll sort it out.'
      );
    });
})();
